import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-widget-summary',
  templateUrl: './widget-summary.component.html',
  styleUrls: ['../widgets.scss', './widget-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WidgetSummaryComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  user$ = this.store.select(fromStore.getCurrentUser);

  isLoading$ = this.store.select(fromStore.getCurrentUserLoading);

  isLoaded$ = this.store.select(fromStore.getCurrentUserLoaded);

  ngOnInit(): void {
    this.store
      .select(fromStore.getCurrentUserLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadCurrentUser());
        }
      });
  }
}
